import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {DesignFiltersDropdown} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignFiltersDropdown';
import {
    DesignsSorting,
    DesignsSortingDirection,
    DesignsSortMenu
} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/DesignsSortMenu';
import {SpaceSelector} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/SpaceSelector';
import {TemplatesCategorySelector} from '@mintdata-wsp/wsp/ui/views/workspace/home/filters/TemplatesCategorySelector';
import * as classnames from 'classnames/bind';
import {action} from 'mobx';
import {observer} from 'mobx-react';
import * as React from 'react';
import {WSPNewDesignButton} from '@mintdata-wsp/wsp/ui/components/general/WSPNewDesignButton';
import {DesignsSearchFilter} from './DesignsSearch';

const styles = require('./DesignsFilters.less');
const cx = classnames.bind(styles);

export enum DesignsFilterType
{
    HomeDesignsMobile = 'HomeDesignsMobile',
    HomeApplicationsMobile = 'HomeApplicationsMobile',
    HomeDesigns = 'HomeDesigns',
    HomeApplications = 'HomeApplications',
    SearchDesigns = 'SearchDesigns',
    SearchApplications = 'SearchApplications',
    SearchTemplates = 'SearchTemplates',
    Designs = 'Designs',
    Spaces = 'Spaces',
    Applications = 'Applications',

    Templates = 'Templates',
}

export interface IDesignsFilters
{
    filter:DesignsFilter;
    sorting:DesignsSorting;
    direction:DesignsSortingDirection;
}

export enum DesignsFilter
{
    All = 'All',
    Recent = 'Recent',
    Published = 'Published',
    Templates = 'Templates',
}

interface Props
{
    filterType:DesignsFilterType;
    className?:string;
}

@observer
export class DesignsFilters extends React.Component<Props, any>
{
    @action.bound
    private _onClickFilter = (nextFilter:DesignsFilter) =>
    {
        const {filterType} = this.props;

        const {getDesignsFilter, getDesignsSorting, setDesignsFilter, setDesignsSorting, setDesignsSearchFilter} = controllers.ui.mainPage;

        // const designsFilter:DesignsFilter = getDesignsFilter(filterType);
        // const designsSorting:DesignsSorting = getDesignsSorting(filterType);

        // if( filterType === DesignsFilterType.SearchDesigns
        //     && designsSorting === DesignsSorting.LastModified
        //     && nextFilter === DesignsFilter.Published
        //     // && designsFilter === DesignsFilter.All
        // )
        // {
        //     setDesignsSorting(filterType, DesignsSorting.DateCreated);
        // }

        if( nextFilter === DesignsFilter.All )
        {
            setDesignsSearchFilter(DesignsSearchFilter.Designs);
            setDesignsFilter(DesignsFilterType.SearchDesigns, nextFilter);
        }

        if( nextFilter === DesignsFilter.Published )
        {
            setDesignsSearchFilter(DesignsSearchFilter.Applications);
            setDesignsFilter(DesignsFilterType.SearchApplications, nextFilter);
        }

        if( nextFilter === DesignsFilter.Templates )
        {
            setDesignsSearchFilter(DesignsSearchFilter.Templates);
            setDesignsFilter(DesignsFilterType.SearchTemplates, nextFilter);
        }

        if( filterType === DesignsFilterType.HomeDesignsMobile )
        {
            setDesignsFilter(DesignsFilterType.HomeApplicationsMobile, nextFilter);
        }

        if( filterType === DesignsFilterType.HomeApplicationsMobile )
        {
            setDesignsFilter(DesignsFilterType.HomeDesignsMobile, nextFilter);
        }

        setDesignsFilter(filterType, nextFilter);
    };

    private _renderFilter = (filter:DesignsFilter, title?:string):JSX.Element =>
    {
        const {filterType} = this.props;

        const designsFilter = controllers.ui.mainPage.getDesignsFilter(filterType);

        return (
            <Row
                key={filter}
                className={cx(styles.filter, {active: designsFilter === filter})}
                onClick={() => this._onClickFilter(filter)}
            >
                {title || filter}
            </Row>
        );
    };

    private _renderFilters = (filters:DesignsFilter[], titles?:string[], desktopOnly:boolean = false):JSX.Element =>
    {
        const {filterType} = this.props;

        return (
            <Row className={styles.filters}>
                <Row className={cx(styles.desktop, {desktopOnly})}>
                    {
                        filters.map((filter:DesignsFilter, index:number) =>
                            this._renderFilter(filter, titles && titles[index] ? titles[index] : null))
                    }
                </Row>
                {
                    !desktopOnly &&
                    <Row className={cx(styles.mobile)}>
                        <DesignFiltersDropdown
                            filterType={filterType}
                            filters={filters}
                            titles={titles}
                            onSelect={this._onClickFilter}
                        />
                    </Row>
                }
            </Row>
        );
    };

    render():JSX.Element
    {
        const {className, filterType} = this.props;

        const designsFilter = controllers.ui.mainPage.getDesignsFilter(filterType);

        return (
            <Row className={cx(styles.wrapper, className)}>
                {
                    (
                        filterType !== DesignsFilterType.Templates &&
                        filterType !== DesignsFilterType.Applications &&
                        filterType !== DesignsFilterType.HomeDesignsMobile &&
                        filterType !== DesignsFilterType.HomeApplicationsMobile &&
                        filterType !== DesignsFilterType.SearchDesigns &&
                        filterType !== DesignsFilterType.SearchApplications &&
                        filterType !== DesignsFilterType.SearchTemplates
                    ) &&
                    <div className={styles.filtersWithNewDesign}>
                        {this._renderFilters(
                            [DesignsFilter.All, DesignsFilter.Recent, DesignsFilter.Published]
                        )}
                        <WSPNewDesignButton />
                    </div>
                }
                {
                    (
                        filterType === DesignsFilterType.SearchDesigns ||
                        filterType === DesignsFilterType.SearchApplications ||
                        filterType === DesignsFilterType.SearchTemplates
                    ) &&
                    this._renderFilters(
                        [DesignsFilter.All, DesignsFilter.Published, DesignsFilter.Templates],
                        ['Designs', 'Applications', 'Templates']
                    )
                }
                {
                    (
                        filterType === DesignsFilterType.HomeDesignsMobile ||
                        filterType === DesignsFilterType.HomeApplicationsMobile
                    ) &&
                    this._renderFilters(
                        [DesignsFilter.All, DesignsFilter.Published],
                        ['Designs', 'Applications'],
                        true
                    )
                }
                {
                    filterType === DesignsFilterType.Applications &&
                    <Row className={styles.filters}>
                        <SpaceSelector
                            showAllItem
                        />
                    </Row>
                }
                {
                    (
                        filterType === DesignsFilterType.Templates
                    ) &&
                    <Row className={styles.filters}>
                        <TemplatesCategorySelector />
                    </Row>
                    // this._renderFilters(
                    //     [DesignsFilter.All],
                    //     ['TODO: templates filter']
                    // )
                }
                {
                    (
                        filterType === DesignsFilterType.SearchTemplates
                    ) &&
                    <Row className={styles.sorting}>
                        <TemplatesCategorySelector />
                    </Row>
                }
                {
                    (
                        filterType !== DesignsFilterType.Templates &&
                        filterType !== DesignsFilterType.SearchTemplates &&
                        filterType !== DesignsFilterType.HomeDesignsMobile &&
                        filterType !== DesignsFilterType.HomeApplicationsMobile
                    ) &&
                    <Row className={styles.sorting}>
                        <DesignsSortMenu
                            filterType={filterType}
                            isDisabled={designsFilter === DesignsFilter.Recent}
                            // designsFilter={designsFilter}
                        />
                    </Row>
                }

            </Row>
        );
    }
}
